import React from 'react';
import { LicenceSchema } from '../../../types/schema';
import { style } from 'typestyle';
import { OrderLicence } from '../molecules/OrderLicence';

interface DownloadLicenseListProps {
  licences: LicenceSchema[];
  currency: string;
}
export const DownloadLicenseList: React.FC<DownloadLicenseListProps> = ({ licences, currency }) => {
  return (
    <div className={styles.container}>
      {licences.map((license) => (
        <OrderLicence licence={license} currency={currency} key={license.identity} isDownload />
      ))}
    </div>
  );
};

const styles = {
  container: style({
    width: '100%',
  }),
};
